import { _ } from "vue-underscore";

const tribuneB = {
  tribunePrefix: "B",
  seats: [..._.range(469, 300, -1)],
  rows: [
    {
      name: 5,
      items: ["empty", "empty", ..._.range(469, 437, -1), "empty", "empty"]
    },
    {
      name: "stairs",
      items: ["stairs", ...Array(34).fill("empty"), "stairs"]
    },
    { name: 4, items: ["empty", ..._.range(436, 402, -1), "empty"] },
    {
      name: "stairs",
      items: ["stairs", ...Array(34).fill("empty"), "stairs"]
    },
    { name: 3, items: ["empty", ..._.range(402, 368, -1), "empty"] },
    {
      name: "stairs",
      items: ["stairs", ...Array(34).fill("empty"), "stairs"]
    },
    { name: 2, items: ["empty", ..._.range(368, 334, -1), "empty"] },
    {
      name: "stairs",
      items: ["stairs", ...Array(34).fill("empty"), "stairs"]
    },
    { name: 1, items: ["empty", ..._.range(334, 300, -1), "empty"] }
  ]
};

export default tribuneB;
